import { makeAutoObservable } from 'mobx'
import { toast, ToastPosition } from 'react-toastify'

export class NotificationStore {
  position: ToastPosition = 'top-right'

  constructor() {
    makeAutoObservable(this)
  }

  showWarning = (text: string, containerId = 'global'): void => {
    toast.warning(text, { containerId })
  }

  showError = (text: string, containerId = 'global'): void => {
    toast.error(text, { containerId })
  }

  showInfo = (text: string, containerId = 'global'): void => {
    toast.info(text, { containerId })
  }

  dismiss = (): void => {
    toast.dismiss()
  }
}
